/* Deja libre el botón de pagar sin sacrificar WhatsApp.
   - Oculta el flotante de Reservar en la carta, el carrito y el checkout.
   - Sube el de WhatsApp justo encima de la barra de "Ver mi pedido".
   En el resto del sitio los dos siguen exactamente igual. */
(function () {
  function alto() {
    var bar = document.querySelector('.crt-bar');
    var h = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--don-bar-h', (h > 0 ? h : 64) + 'px');
  }

  function marcar() {
    var main = document.querySelector('main[data-template]');
    var tpl = main ? (main.getAttribute('data-template') || '') : '';
    var ruta = (window.location.pathname || '').toLowerCase();

    var esCarrito = tpl.indexOf('cart') === 0 || ruta.indexOf('/cart') === 0 || ruta.indexOf('/checkout') === 0;
    var esCarta = !!document.querySelector('[data-crt]');

    if (esCarrito || esCarta) {
      document.documentElement.classList.add('don-pagar-libre');
      alto();
    } else {
      document.documentElement.classList.remove('don-pagar-libre');
    }
  }

  marcar();
  document.addEventListener('DOMContentLoaded', marcar);
  window.addEventListener('pageshow', marcar);
  window.addEventListener('resize', alto);
  window.addEventListener('orientationchange', alto);
})();